/**
 * handlers/views.ts
 * Panel / view switching: History, Insights, Workflows, Personal Facts, Chat.
 */

import { state, resetForNewConversation } from '../state';
import { dom } from '../dom';
import { showWelcome, renderSuggestions } from '../ui-renderers';
import { updateContextBar, _hideBottomChrome, _setNavBtns, focusInput, isClientUser } from './helpers';
import { loadConversationList } from './conversations';
import { loadInsights } from './insights';
import { loadWorkflows } from './workflows';
import { loadPersonalFacts } from './personal-facts';

export function showHistory() {
  state.view = 'history';
  dom.msgsContainer.classList.add('hidden');
  dom.history.classList.add('open');
  dom.insights.classList.remove('open');
  dom.workflowsPanel?.classList.remove('open');
  dom.personalFactsPanel?.classList.remove('open');
  _setNavBtns('hide');
  if (dom.ctxBar)   dom.ctxBar.style.display   = 'none';
  if (dom.inputRow) dom.inputRow.style.display  = 'none';
  _hideBottomChrome();
  loadConversationList();

  const newsPanel = document.getElementById('ai-news');
  if (newsPanel) newsPanel.style.display = 'none';
}

export function showInsights() {
  state.view = 'insights';
  dom.msgsContainer.classList.add('hidden');
  dom.history.classList.remove('open');
  dom.insights.classList.add('open');
  dom.workflowsPanel?.classList.remove('open');
  dom.personalFactsPanel?.classList.remove('open');
  _setNavBtns('hide');
  if (dom.ctxBar)   dom.ctxBar.style.display   = 'none';
  if (dom.inputRow) dom.inputRow.style.display  = 'none';
  _hideBottomChrome();
  loadInsights();

  const newsPanel = document.getElementById('ai-news');
  if (newsPanel) newsPanel.style.display = 'none';
}

/**
 * Switch to the Workflows panel.
 * Hidden for client users; main.js also hides the trigger button.
 */
export function showWorkflows() {
  if (isClientUser()) return;
  state.view = 'workflows';
  dom.msgsContainer.classList.add('hidden');
  dom.history.classList.remove('open');
  dom.insights.classList.remove('open');
  dom.workflowsPanel?.classList.add('open');
  dom.personalFactsPanel?.classList.remove('open');
  _setNavBtns('hide');
  if (dom.ctxBar)   dom.ctxBar.style.display   = 'none';
  if (dom.inputRow) dom.inputRow.style.display  = 'none';
  _hideBottomChrome();
  loadWorkflows();

  const newsPanel = document.getElementById('ai-news');
  if (newsPanel) newsPanel.style.display = 'none';
}

/**
 * Switch to the Personal Facts panel.
 * Available for all authenticated user roles.
 */
export function showPersonalFacts() {
  state.view = 'personalfacts';
  dom.msgsContainer.classList.add('hidden');
  dom.history.classList.remove('open');
  dom.insights.classList.remove('open');
  dom.workflowsPanel?.classList.remove('open');
  dom.personalFactsPanel?.classList.add('open');
  _setNavBtns('hide');
  if (dom.ctxBar)   dom.ctxBar.style.display   = 'none';
  if (dom.inputRow) dom.inputRow.style.display  = 'none';
  _hideBottomChrome();
  loadPersonalFacts();
  document.dispatchEvent(new CustomEvent('akili:show-privacy')); // [PHASE 3]

  const newsPanel = document.getElementById('ai-news');
  if (newsPanel) newsPanel.style.display = 'none';
}

export function showChat() {
  state.view = 'chat';
  dom.msgsContainer.classList.remove('hidden');
  dom.history.classList.remove('open');
  dom.insights.classList.remove('open');
  dom.workflowsPanel?.classList.remove('open');
  dom.personalFactsPanel?.classList.remove('open');
  _setNavBtns('show');
  if (dom.ctxBar)   dom.ctxBar.style.display   = 'flex';
  if (dom.inputRow) dom.inputRow.style.display  = 'flex';

  const modeBar    = document.getElementById('ai-mode-bar');
  const disclaimer = document.querySelector('.ai-disclaimer') as HTMLElement | null;
  if (modeBar)    modeBar.style.display    = '';
  if (disclaimer) disclaimer.style.display = '';

  if (dom.proactivePanel) dom.proactivePanel.style.display = '';
  if (dom.psPill)         dom.psPill.style.display         = '';
  if (dom.docChip)        dom.docChip.style.display        = '';

  updateContextBar();
  renderSuggestions();

  const newsPanel = document.getElementById('ai-news');
  if (newsPanel) newsPanel.style.display = 'none';
}

export function newConversation() {
  resetForNewConversation();
  const msgs = dom.msgs;
  if (msgs) msgs.innerHTML = '';
  showChat();
  showWelcome();
  focusInput();
  // Kili Sentient: reset avatar emotion on new conversation
  import('../emotion-avatar').then(m => m.resetAvatarEmotion());
}
